import React from "react";
import { Link } from "react-router-dom";
import { Tab, Icon } from "semantic-ui-react";

import { Caption, Subheader, Directions, ButtonRow, Button, ButtonLabel } from './common';

// import styled from "tachyons-components";
import styles from "./styles.module.scss";
import { LEVER_TYPE, ConnectedSlider, ConnectedBubblePicker, ConnectedToggle } from './numberSelectors';

// These are redux controlled components
// For now, do a copy paste for the "discrete" and 'slider" selectors.
const ModalSplitSelector = (props) => {
  return (
    <div className={styles.selectorRow}>
      <div className={styles.splitIcon}><Icon name={props.icon}/> </div>
      <div className={styles.splitLabel}>{props.name}</div>
      <div className={styles.splitSelector}>
        <ConnectedBubblePicker start={0} end={4} leverName={props.lever} scenarioKey={props.scenarioKey}/>
      </div>
    </div>
  )
}

const ElectrificationSelector = (props) => {
  return <div className={styles.selectorRow}>
      <div className={styles.splitIcon}>
        <Icon name={props.icon} />{" "}
      </div>
      <div className={styles.splitLabel}>{props.name}</div>
      <div className={styles.splitSlider}>
        <ConnectedSlider leverName={props.lever} scenarioKey={props.scenarioKey}/>
      </div>
    </div>;
}

const RenewableTargetsSelector = (props) => {
  return <div className={styles.selectorRow}>
      <div className={styles.splitIcon}>
        <Icon name="recycle" />{" "}
      </div>
      <div className={styles.splitLabel}>
        Does you city have (or is currently developing plans for) targets for renewable sourced energy?
      </div>
      <div className={styles.splitSlider}>
        <ConnectedToggle scenarioKey={props.scenarioKey} leverName="hasRenewableEnergyTarget" />
      </div>
    </div>;
}

const InputPane = () => {

  const scenarioKey = "primary"; // Future: could make this overrideable

  // Discrete = 0 - 4
  const discreteStrategies = [
    { name: "Non-motorized Transit (e.g., investing in walking and cycling infrastructure)", icon: 'bicycle', lever: LEVER_TYPE.nonMotorizedTransit },
    { name: "Shared Mobility (e.g., promoting sharing of 2-, 3-, and 4-wheel vehicles)", icon: 'taxi', lever: LEVER_TYPE.sharedMobility },
    { name: "Public Transit (encouraging public transit, both bus and rail, use by improving access and service)", icon: 'train', lever: LEVER_TYPE.publicTransit},
  ];

  // ContinuousStrategies = sliders from 0 - 100;
  const continuousStrategies = [
    { name: "Public and Commercial Vehicles", icon: 'bus', lever: LEVER_TYPE.publicCommercialElectrificationVehicleGoal },
    { name: "Private Vehicles", icon: 'car', lever: LEVER_TYPE.privateElectrificationVehicleGoal },
  ];

  return <Tab.Pane attached={true}>
      <Caption>
        Please define your city's efforts and targets for a shared, clean, and people-centric mobility future.
      </Caption>

      <Subheader> Modal Split</Subheader>
      <Directions>
        Input the degree of future investments, where 0 reflects business-as-usual and 3 is a strong commitment to a shared, clean, and people-centric future. Place your cursor over the numbers to learn more.
      </Directions>

      {discreteStrategies.map(strategy => (
        <ModalSplitSelector
          key={strategy.name}
          {...strategy}
          scenarioKey={scenarioKey}
        />
      ))}

      <Subheader> Electrification </Subheader>

      <Directions>
        Input 2035 fleet electrification targets for privately-, commercially-, and publicly-operated vehicles.
      </Directions>

      {continuousStrategies.map(strategy => (
        <ElectrificationSelector
          key={strategy.name}
          {...strategy}
          scenarioKey={scenarioKey}
        />
      ))}

    <Subheader> Electricity Source </Subheader>

      <RenewableTargetsSelector scenarioKey={scenarioKey}/>

      <ButtonRow>
        <Link to="/results">
          <Button>
            <ButtonLabel>Next > </ButtonLabel>
          </Button>
        </Link>
      </ButtonRow>
    </Tab.Pane>;
}

export default InputPane;



// WEBPACK FOOTER //
// ./src/pages/modelLevers/panes/input.js